// TODO: задача на рефакторинг https://jira.cian.tech/browse/CD-189526
import { ERegions } from '@cian/chats-api/lib/browser-entry';
import { IStyleConfig, mergeStyles } from '@cian/utils/lib/shared/style';
import * as React from 'react';

import { isPrimaryMetroRegion } from './helpers';
import { HighwaysIcon } from './highways_icon';
import { Underground } from './underground';
import { TOfferGeo } from '../../types/offer';

const style = require('./index.css');

interface IAddressProps {
  geo: TOfferGeo;
  containerStyles?: IStyleConfig;
}

interface IAddress {
  name?: string | null;
}

const getAddressString = (address: IAddress[]) =>
  address
    .map(a => a.name)
    .join(', ')
    .trim();

const getDistanceFromName = (regionId?: number) => {
  switch (regionId) {
    case ERegions.moscow:
    case ERegions.moscowArea:
      return 'МКАД';
    case ERegions.spb:
    case ERegions.spbArea:
      return 'КАД';
    default:
      return 'центра';
  }
};

const parseHighwayDistance = (regionId: number | undefined, distance: string | number | null | undefined) => {
  if (!distance) {
    return '';
  }

  return `, ${Number(distance).toFixed(0)} км от ${getDistanceFromName(regionId)}`;
};

export class Address extends React.PureComponent<IAddressProps, object> {
  public render() {
    const { containerStyles } = this.props;

    return <div {...mergeStyles(style['address'], containerStyles)}>{this.renderAddress()}</div>;
  }

  private renderAddress() {
    const { geo } = this.props;
    const underground = this.getUnderground();
    const highway = this.getHighway();
    const address = this.getAddress();

    if (underground && isPrimaryMetroRegion(geo)) {
      const locationId = (geo && geo.address && geo.address.length > 0 && geo.address[0].id) || undefined;

      return <Underground underground={underground} locationId={locationId} />;
    }

    if (highway && highway.name) {
      const { name, distance } = highway;

      return (
        <span className={style['highway']}>
          <span className={style['highway-icon']}>
            <HighwaysIcon />
          </span>
          &nbsp;
          {name} шоссе
          {parseHighwayDistance(geo.address?.[0].locationTypeId ?? undefined, distance)}
        </span>
      );
    }

    return <span className={style['full_address']}>{address}</span>;
  }

  private getAddress() {
    const { geo } = this.props;

    return geo.address && geo.address.length > 3
      ? getAddressString(geo.address.slice(geo.address.length - 3))
      : geo.address && getAddressString(geo.address);
  }

  private getUnderground() {
    const { geo } = this.props;

    if (geo?.undergrounds) {
      const offerUndergrounds = geo.undergrounds
        .concat()
        .sort(({ time: timeA }, { time: timeB }) => (timeA ?? 0) - (timeB ?? 0));

      return offerUndergrounds.find(underground => underground.isDefault) || offerUndergrounds[0];
    }

    return undefined;
  }

  private getHighway() {
    const { geo } = this.props;

    if (geo.highways) {
      const highways = geo.highways.concat().sort((a, b) => Number(a.distance) - Number(b.distance));

      return highways.find(h => Boolean(h.isDefault)) || highways[0];
    }

    return undefined;
  }
}
